module.exports = __webpack_public_path__ + "static/media/ic-secure.89bb1501.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-secure.svg
// module id = 662
// module chunks = 14